var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-b-5" },
    [
      _c("RemoveAssetModal", {
        attrs: {
          "show-modal": _vm.showModal,
          "asset-id": _vm.showModalId,
          "asset-name": _vm.showModalName
        },
        on: {
          "remove-asset": function($event) {
            return _vm.removeAsset(_vm.showModalId)
          },
          "hide-modal": _vm.hideModal
        }
      }),
      _vm._v(" "),
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.assetsList,
            "current-page": _vm.currentPage,
            "page-size": 20,
            "hide-sort-icons": true
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  _vm._l(displayData, function(row) {
                    return _c("tr", { key: row.id }, [
                      _c("td", [_vm._v(_vm._s(row.originalFileName))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.contentType) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center" },
                        [
                          _c("RecordingButton", {
                            attrs: { "recording-url": row.publicUrl }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "actions-collapsed-list" }, [
                          _c("div", { staticClass: "action-icon" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-list-function",
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function($event) {
                                    return _vm.showRemoveAsset(
                                      row.id,
                                      row.originalFileName
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "typcn typcn-trash",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "DELETE",
                                      expression: "'DELETE'"
                                    }
                                  ],
                                  staticClass: "hint-text-mobile"
                                })
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  }),
                  0
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ASSETS_TABLE_ROW_NAME",
                      expression: "'ASSETS_TABLE_ROW_NAME'"
                    }
                  ],
                  attrs: { "sort-key": "originalFileName" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ASSETS_TABLE_ROW_FORMAT",
                      expression: "'ASSETS_TABLE_ROW_FORMAT'"
                    }
                  ],
                  attrs: { "sort-key": "contentType" }
                }),
                _vm._v(" "),
                _c("th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "ASSETS_TABLE_RECORDING",
                      expression: "'ASSETS_TABLE_RECORDING'"
                    }
                  ],
                  staticClass: "text-center"
                }),
                _vm._v(" "),
                _c("th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "TABLE_COL_ACTIONS",
                      expression: "'TABLE_COL_ACTIONS'"
                    }
                  ]
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 10
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.getAssetsStatus.status === "pending"
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ASSETS_TABLE_LOADING",
                    expression: "'ASSETS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getAssetsStatus.status === "success" &&
      _vm.assetsList &&
      _vm.assetsList.length === 0
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "ASSETS_TABLE_EMPTY",
                expression: "'ASSETS_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }